import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "./../UserManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const UserManagmentInfoCard = (props) => {
    return (
        <>
            <div dir="rtl" className={`text-right mx-4 px-2 pt-2 pb-3 mt-2 mb-3`}>
                <div className={`d-flex align-items-start justify-content-between flex-wrap`}>
                    {
                        props.userManagmentInfoData?.map((data) => (
                            <div key={data.id} className={`d-flex align-items-center justify-content-start mt-3 mb-2 p-3 ${styles.total_user_managment_card_box}`}>
                                <img className={`${styles.image_user_managment_card_box}`} loading="lazy" src={`https://backdev.azrmelk.com/images/users/avatar/${data?.avatarName}`} alt="user-profile" />
                                <h5 className={`pe-3 mb-0 ${styles.title_user_managment_card_box}`}> {data.name + " " + data.family} </h5>
                                <Link
                                    to={{
                                        pathname: `/user-managment-info-detail/${data.id}`,
                                        state: data
                                    }}
                                    // to={`/user-managment-info-detail/${data.id}`}
                                    className={`me-auto ${styles.link_icon_text}`}>
                                    بیشتر
                                    <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="12" />
                                </Link>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default UserManagmentInfoCard;
